import { pacingAdvertiserFilter, pacingAdvertiserMapper } from '@/helpers/pacing/slice';
import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectSharedApiClients, selectSharedApiWhitelabels } from './sharedApi.selectors';

export const selectPacing = (state: RootState) => state.pacing;

export const selectPacingNoPacingData = createSelector(
  [selectPacing],
  ({ noBeeswaxPacingData, noGooglePacingData }) => !!(noBeeswaxPacingData && noGooglePacingData),
);

export const selectPacingData = createSelector(
  [selectPacing],
  ({ beeswaxPacingData, googlePacingData, beeswaxPacingDataRequestId, googlePacingDataRequestId }) =>
    beeswaxPacingDataRequestId || googlePacingDataRequestId
      ? []
      : [...(beeswaxPacingData || []), ...(googlePacingData || [])],
);

export const selectPacingDataLoading = createSelector(
  [selectPacing],
  ({ beeswaxPacingDataRequestId, googlePacingDataRequestId }) =>
    !!(beeswaxPacingDataRequestId || googlePacingDataRequestId),
);

export const selectPacingCampaigns = createSelector([selectPacing], ({ campaigns, campaignsRequestId }) => ({
  campaigns,
  loadingCampaigns: !!campaignsRequestId,
}));

export const selectPacingFilters = createSelector([selectPacing], ({ filters }) => filters);

export const pacingWhitelabelsSelector = (state: RootState) =>
  selectSharedApiWhitelabels(state, pacingAdvertiserMapper, pacingAdvertiserFilter);
export const pacingClientsSelector = (state: RootState) =>
  selectSharedApiClients(state, pacingAdvertiserMapper, pacingAdvertiserFilter);

export const selectPacingWhitelabels = createSelector([pacingWhitelabelsSelector], ({ whitelabels }) => whitelabels);
export const selectPacingClients = createSelector([pacingClientsSelector], ({ clients }) => clients);
